import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { countryCodeToEmoji } from "./countries";
export var playerDisplayName = function (player) {
    if (!player) {
        return "";
    }
    var model = player.user || player.externalUser;
    if (model === null) {
        throw new Error("Cannot retrieve Player User!");
    }
    return "".concat(model.firstName, " ").concat(model.lastName);
};
export var PlayerDisplayNameLink = function (_a) {
    var player = _a.player, _b = _a.reverse, reverse = _b === void 0 ? false : _b;
    var displayName = playerDisplayName(player);
    if (!player) {
        return _jsx(Fragment, { children: displayName });
    }
    return PlayerNameLink({
        id: player.id,
        name: displayName,
        nationality: player.nationality,
        reverse: reverse,
    });
};
export var PlayerNameLink = function (_a) {
    var id = _a.id, name = _a.name, nationality = _a.nationality, _b = _a.reverse, reverse = _b === void 0 ? false : _b;
    return (_jsx(Link, { style: { textDecoration: "none" }, to: "/players/".concat(id, "/"), children: reverse
            ? "".concat(name, " ").concat(countryCodeToEmoji(nationality))
            : "".concat(countryCodeToEmoji(nationality), " ").concat(name) }, id));
};
